import React, { FC } from 'react';

import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';

interface RecordDetailPageProps {
  isOnline?: boolean;
}

const OfflineWarningAlert: FC<RecordDetailPageProps> = (props) => {
  const { isOnline } = props;

  return (
    !isOnline && (
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Alert severity="warning">
          You are offline. Your work will be saved to your device. Remember to submit after you are back online.
        </Alert>
      </Grid>
    )
  );
};

export default OfflineWarningAlert;
